const BOC_MERCHANT_LIB = 'https://ebsnew.boc.cn/bocphone/BocMerchant/';
const BOC_CHANNEL_NO = 107;
const BOC_MER_ID = '10892';
const BOC_PAY_MERCHANT_NO = '104330145117001';
// 中行侧开通 callPcpsPaymentControl 白名单后再改为 true
const USE_PCPS_PAYMENT = false;
const USE_ENCRYPT_USER_UNIQUE_ID = true;
const BOC_IDENTITY_BRIDGE_METHOD = USE_ENCRYPT_USER_UNIQUE_ID
  ? 'getEncryptUserUniqueId'
  : 'getBocCustomerAllInfo';
const LOONGAIR_MINI_PROGRAM = {
  userName: 'gh_07be6ce5a8ea',
  path: 'pages/index/home',
};

const BRIDGE_CALL_TIMEOUT = 10000;
const DEVICE_READY_TIMEOUT = 3000;

function isBocApp() {
  // 中行官方：UA 含 bocapp 即为中行 App（需 toLowerCase）
  const browser = (navigator.userAgent || '').toLowerCase();
  return browser.indexOf('bocapp') > -1;
}

function onDeviceReady() {
  return new Promise((resolve, reject) => {
    if (window.c_plugins && window.c_plugins.merchantBridge) {
      resolve();
      return;
    }
    let settled = false;
    const onReady = () => {
      if (settled) {
        return;
      }
      settled = true;
      document.removeEventListener('deviceready', onReady, false);
      if (window.c_plugins && window.c_plugins.merchantBridge) {
        resolve();
      } else {
        reject(new Error('当前环境不支持中行客户端能力'));
      }
    };
    document.addEventListener('deviceready', onReady, false);
    setTimeout(() => {
      if (settled) {
        return;
      }
      settled = true;
      document.removeEventListener('deviceready', onReady, false);
      reject(new Error('中行客户端能力初始化超时'));
    }, DEVICE_READY_TIMEOUT);
  });
}

function callMerchantBridge(method, params, timeout = BRIDGE_CALL_TIMEOUT) {
  return new Promise((resolve, reject) => {
    if (!window.c_plugins || !window.c_plugins.merchantBridge || !window.c_plugins.merchantBridge[method]) {
      reject(new Error('当前环境不支持中行客户端能力'));
      return;
    }
    let settled = false;
    const timer = setTimeout(() => {
      if (settled) {
        return;
      }
      settled = true;
      reject(new Error('中行客户端能力调用超时'));
    }, timeout);
    window.c_plugins.merchantBridge[method](
      function (data) {
        if (settled) {
          return;
        }
        settled = true;
        clearTimeout(timer);
        resolve(data || {});
      },
      function (err) {
        if (settled) {
          return;
        }
        settled = true;
        clearTimeout(timer);
        reject(err || new Error('网络错误，请检查网络连接'));
      },
      params || {}
    );
  });
}

function getBridgeDiagnostics(method = BOC_IDENTITY_BRIDGE_METHOD) {
  const bridge = window.c_plugins && window.c_plugins.merchantBridge;
  const bridgeMethods = bridge ? Object.keys(bridge).filter(key => typeof bridge[key] === 'function') : [];
  return {
    pageUrl: location.href,
    protocol: location.protocol,
    hostname: location.hostname,
    userAgent: navigator.userAgent || '',
    isBocApp: isBocApp(),
    appVersion: (window.terminal && window.terminal.appVersion) || '',
    isAndroid: !!(window.terminal && window.terminal.android),
    isIOS: !!(window.terminal && (window.terminal.iPhone || window.terminal.iPad)),
    hasCPlugins: !!window.c_plugins,
    hasMerchantBridge: !!bridge,
    hasTargetMethod: !!(bridge && bridge[method]),
    bridgeMethods,
    merId: BOC_MER_ID,
    bocScriptLoaded: !!document.querySelector('script[src*="BocMerchant"]'),
  };
}

function formatBridgeError(err, method = BOC_IDENTITY_BRIDGE_METHOD) {
  const diagnostics = getBridgeDiagnostics(method);
  let reason = '未知错误';
  const message = (err && err.message) || String(err || '');

  if (message.indexOf('当前环境不支持中行客户端能力') > -1) {
    if (!diagnostics.hasCPlugins) {
      reason = 'window.c_plugins 未注入，Cordova/中行 JS 可能未加载';
    } else if (!diagnostics.hasMerchantBridge) {
      reason = 'merchantBridge 不存在，BocMerchant 脚本可能未加载完成';
    } else if (!diagnostics.hasTargetMethod) {
      reason = `merchantBridge.${method} 方法不存在`;
    }
  } else if (message.indexOf('超时') > -1) {
    reason = 'Bridge 已调用但 10s 内无回调，常见于 HTTP 本地页、域名未白名单、Android 加载了 ios.js';
  } else if (message.indexOf('网络错误') > -1) {
    reason = 'Bridge 返回失败回调，需看中行 App 侧错误详情';
  } else {
    reason = message;
  }

  return { reason, message, diagnostics };
}

function normalizeCipherText(cipherText) {
  if (!cipherText) {
    return '';
  }
  if (typeof cipherText === 'object') {
    return JSON.stringify(cipherText);
  }
  return String(cipherText).trim();
}

function getBocCustomerAllInfo(merId = BOC_MER_ID) {
  return callMerchantBridge('getBocCustomerAllInfo', { merId });
}

function getEncryptUserUniqueId(merId = BOC_MER_ID) {
  const params = merId ? { merId } : {};
  return callMerchantBridge('getEncryptUserUniqueId', params);
}

function parseBocCustomerAllInfoResult(data) {
  if (!data) {
    return '';
  }
  if (typeof data === 'string') {
    return normalizeCipherText(data);
  }
  return normalizeCipherText(data.cipherText);
}

function parseEncryptUserUniqueIdResult(data) {
  if (!data) {
    return '';
  }
  if (typeof data === 'string') {
    return normalizeCipherText(data);
  }
  return normalizeCipherText(
    data.cipherText || data.encryptUserUniqueId || data.uniqueIdCipherText
  );
}

function parseBocIdentityResult(data) {
  if (USE_ENCRYPT_USER_UNIQUE_ID) {
    return parseEncryptUserUniqueIdResult(data);
  }
  return parseBocCustomerAllInfoResult(data);
}

function fetchBocIdentityFromBridge(merId = BOC_MER_ID) {
  if (USE_ENCRYPT_USER_UNIQUE_ID) {
    return getEncryptUserUniqueId(merId);
  }
  return getBocCustomerAllInfo(merId);
}

function clearStoredCipherText() {
  sessionStorage.removeItem('bocCipherText');
}

async function fetchBocCustomerIdentity(merId = BOC_MER_ID) {
  await onDeviceReady();
  const data = await fetchBocIdentityFromBridge(merId);
  const cipherText = parseBocIdentityResult(data);
  if (cipherText) {
    sessionStorage.setItem('bocCipherText', cipherText);
  }
  return {
    cipherText,
    raw: data,
  };
}

function getBrowserType() {
  const ua = navigator.userAgent || '';
  if ((ua || '').toLowerCase().indexOf('bocapp') > -1) {
    return 'BOCApp';
  }
  if (/MicroMessenger/i.test(ua)) {
    return 'WeChat';
  }
  if (/Alipay/i.test(ua)) {
    return 'Alipay';
  }
  if (/Chrome/i.test(ua)) {
    return 'Chrome';
  }
  if (/Safari/i.test(ua)) {
    return 'Safari';
  }
  return 'Other';
}

function buildUserLoginLog() {
  const terminal = window.terminal || {};
  const ua = navigator.userAgent || '';
  let deviceInfo = ua;
  if (terminal.iPhone) {
    deviceInfo = `iPhone; ${ua}`;
  } else if (terminal.iPad) {
    deviceInfo = `iPad; ${ua}`;
  } else if (terminal.android) {
    deviceInfo = `Android; ${ua}`;
  }
  return {
    deviceInfo,
    clientInfo: isBocApp() ? 'BOCApp WebView' : 'H5',
    appVersion: terminal.appVersion || '',
    browser: getBrowserType(),
  };
}

function buildChannelAutoLoginParams(jsCode) {
  const normalizedJsCode = normalizeCipherText(jsCode);
  if (!normalizedJsCode) {
    throw new Error('缺少 jsCode');
  }
  return {
    jsCode: normalizedJsCode,
    channelType: BOC_CHANNEL_NO,
    saleChannel: BOC_CHANNEL_NO,
    userLoginLog: buildUserLoginLog(),
  };
}

function buildChannelMobileCodeLoginParams(params = {}) {
  const code = params.code || params.verifyCode;
  const payload = {
    mobile: params.mobile,
    code,
    saleChannel: BOC_CHANNEL_NO,
    verifyId: params.verifyId,
    channelType: BOC_CHANNEL_NO,
    userLoginLog: buildUserLoginLog(),
  };
  if (params.cipherText) {
    payload.cipherText = params.cipherText;
  }
  return payload;
}

function buildLoginLevelParams(loginLevel) {
  return loginLevel ? { loginLevel: String(loginLevel) } : {};
}

function parseJudgeLoginResult(data) {
  if (data === 'yes' || data === 'no') {
    return data === 'yes';
  }
  if (typeof data === 'string') {
    try {
      data = JSON.parse(data);
    } catch (e) {
      return false;
    }
  }
  const isLogin = data && (data.isLogin || data.islogin);
  return isLogin === 'yes' || isLogin === true || isLogin === '1';
}

function parseContinueLoginResult(data) {
  if (typeof data === 'string') {
    try {
      data = JSON.parse(data);
    } catch (e) {
      return false;
    }
  }
  const isSuccessLogin = data && (data.isSuccessLogin || data.isSuccesslogin);
  return isSuccessLogin === '1' || isSuccessLogin === 1 || isSuccessLogin === true;
}

async function judgeBocLogin(options = {}) {
  await onDeviceReady();
  const data = await callMerchantBridge('judgeLogin', buildLoginLevelParams(options.loginLevel));
  return {
    isLogin: parseJudgeLoginResult(data),
    raw: data,
  };
}

async function continueBocLogin(options = {}) {
  await onDeviceReady();
  const data = await callMerchantBridge(
    'continueAfterLogin',
    buildLoginLevelParams(options.loginLevel),
    options.timeout || BRIDGE_CALL_TIMEOUT * 6
  );
  return {
    isSuccessLogin: parseContinueLoginResult(data),
    raw: data,
  };
}

async function ensureBocAppLogin(options = {}) {
  const judgeResult = await judgeBocLogin(options);
  if (judgeResult.isLogin) {
    return judgeResult;
  }
  if (options.skipContinueLogin) {
    return { isLogin: false, raw: judgeResult.raw };
  }
  const continueResult = await continueBocLogin(options);
  return {
    isLogin: continueResult.isSuccessLogin,
    raw: continueResult.raw,
  };
}

function normalizeBocPaymentValue(value) {
  if (value === undefined || value === null) {
    return '';
  }
  return String(value).replace(/\r?\n/g, '').trim();
}

function isPkcs7DerBinaryString(value) {
  if (!value || typeof value !== 'string') {
    return false;
  }
  return value.charCodeAt(0) === 0x30;
}

function isLikelyBase64Signature(value) {
  const cleaned = normalizeBocPaymentValue(value);
  if (!cleaned || cleaned.length < 64) {
    return false;
  }
  return /^[A-Za-z0-9+/=]+$/.test(cleaned);
}

function looksLikePlainPaymentField(str) {
  if (/^[0-9]{1,20}$/.test(str)) {
    return true;
  }
  if (/^[0-9]+(\.[0-9]+)*$/.test(str)) {
    return true;
  }
  if (/^[A-Za-z0-9]{1,8}$/.test(str)) {
    return true;
  }
  return false;
}

function isAlreadyBase64EncodedParam(value) {
  const str = normalizeBocPaymentValue(value);
  if (!str || looksLikePlainPaymentField(str)) {
    return false;
  }
  if (!/^[A-Za-z0-9+/=]+$/.test(str)) {
    return false;
  }
  try {
    let decoded = '';
    if (typeof atob === 'function') {
      decoded = atob(str);
    } else if (typeof Buffer !== 'undefined') {
      decoded = Buffer.from(str, 'base64').toString('utf8');
    } else {
      return false;
    }
    const reencoded = encodePaymentControlParam(decoded);
    return reencoded === str;
  } catch (err) {
    return false;
  }
}

function encodePaymentControlParam(value) {
  const str = normalizeBocPaymentValue(value);
  if (!str) {
    return '';
  }
  if (typeof btoa === 'function') {
    try {
      return btoa(str);
    } catch (err) {
      return btoa(unescape(encodeURIComponent(str)));
    }
  }
  if (typeof Buffer !== 'undefined') {
    return Buffer.from(str, 'utf8').toString('base64');
  }
  return str;
}

function encodePaymentControlParamIfNeeded(value) {
  const str = normalizeBocPaymentValue(value);
  if (!str) {
    return '';
  }
  if (isAlreadyBase64EncodedParam(str)) {
    return str;
  }
  return encodePaymentControlParam(str);
}

function prepareMessageForBridge(message) {
  const normalized = normalizeBocPaymentValue(message);
  if (!normalized) {
    return '';
  }
  if (normalized.charAt(0) === '<') {
    return encodePaymentControlParam(normalized);
  }
  if (isAlreadyBase64EncodedParam(normalized)) {
    return normalized;
  }
  return normalized;
}

function prepareSignatureForBridge(signature) {
  const normalized = normalizeBocPaymentValue(signature);
  if (!normalized) {
    return '';
  }
  // Bridge 内部会对 signature 做 Base64 解码，必须上送 Base64 字符串，不能传 PKCS#7 二进制
  if (isLikelyBase64Signature(normalized)) {
    return normalized;
  }
  if (isPkcs7DerBinaryString(normalized)) {
    if (typeof btoa === 'function') {
      return btoa(normalized);
    }
    if (typeof Buffer !== 'undefined') {
      return Buffer.from(normalized, 'binary').toString('base64');
    }
  }
  return normalized;
}

function normalizePaymentControlFields(data = {}) {
  const payData = data.payData || data.PayData || {};
  const nested = data.pay_info || data.payInfo || data.PayInfo || {};
  const source = Object.assign({}, nested, payData, data);
  return {
    merchantNo: source.merchantNo || source.MerchantNo || BOC_PAY_MERCHANT_NO,
    version: source.version || source.Version || '1.0.1',
    messageId: source.messageId || source.MessageId || source.messageid || '0000212',
    security: source.security || source.Security || 'P7',
    message: normalizeBocPaymentValue(source.message || source.Message),
    signature: normalizeBocPaymentValue(source.signature || source.Signature),
    custBackFlag: source.custBackFlag || source.CustBackFlag || '1',
    payUrlInfo: source.payUrlInfo || source.PayUrlInfo,
  };
}

function extractBocPayPayload(payResultData = {}) {
  return normalizePaymentControlFields(payResultData);
}

function hasPaymentControlFields(data = {}) {
  return !!(data.message && data.signature);
}

function parsePayUrlInfo(payUrlInfo) {
  if (!payUrlInfo) {
    return null;
  }
  if (typeof payUrlInfo === 'object') {
    const normalized = normalizePaymentControlFields(payUrlInfo);
    if (hasPaymentControlFields(normalized)) {
      return { mode: 'control', data: normalized };
    }
    if (normalized.payUrlInfo) {
      return parsePayUrlInfo(normalized.payUrlInfo);
    }
    return null;
  }
  if (typeof payUrlInfo !== 'string') {
    return null;
  }

  const trimmed = payUrlInfo.trim();
  if (!trimmed) {
    return null;
  }

  if (trimmed.charAt(0) === '{' || trimmed.charAt(0) === '[') {
    try {
      return parsePayUrlInfo(JSON.parse(trimmed));
    } catch (e) {
      return null;
    }
  }

  return null;
}

function buildPaymentControlParams(payData) {
  const merchantNo = payData.merchantNo || BOC_PAY_MERCHANT_NO;
  const version = payData.version || '1.0.1';
  const messageId = payData.messageId || '0000212';
  const security = payData.security || 'P7';
  const message = prepareMessageForBridge(payData.message);
  const custBackFlag = payData.custBackFlag || '1';
  const params = {
    merchantNo: encodePaymentControlParamIfNeeded(merchantNo),
    version: encodePaymentControlParamIfNeeded(version),
    messageId: encodePaymentControlParamIfNeeded(messageId),
    security: encodePaymentControlParamIfNeeded(security),
    message,
    signature: prepareSignatureForBridge(payData.signature),
    custBackFlag: encodePaymentControlParamIfNeeded(custBackFlag),
  };
  if (!params.message) {
    delete params.message;
  }
  if (!params.signature) {
    delete params.signature;
  }
  return params;
}

function buildPcpsPaymentParams(payUrlInfo, payContext = {}) {
  const params = {
    payUrlInfo,
    PayUrlInfo: payUrlInfo,
    custBackFlag: '1',
    CustBackFlag: '1',
  };
  if (payContext.orderId) {
    params.orderId = payContext.orderId;
    params.OrderId = payContext.orderId;
  }
  if (payContext.payPlatCode !== undefined && payContext.payPlatCode !== null && payContext.payPlatCode !== '') {
    params.payPlatCode = payContext.payPlatCode;
    params.PayPlatCode = payContext.payPlatCode;
  }
  if (payContext.payInfoTids) {
    params.payInfoTids = payContext.payInfoTids;
    params.PayInfoTids = payContext.payInfoTids;
  }
  return params;
}

function resolveBocPaymentBridgeMethod(payUrlInfo) {
  const parsed = parsePayUrlInfo(payUrlInfo);
  if (!parsed) {
    return '';
  }
  if (parsed.mode === 'pcps' && USE_PCPS_PAYMENT) {
    return 'callPcpsPaymentControl';
  }
  return 'callPaymentControl';
}

async function callPaymentControl(params) {
  await onDeviceReady();
  return callMerchantBridge('callPaymentControl', params);
}

async function callPcpsPaymentControl(params) {
  await onDeviceReady();
  return callMerchantBridge('callPcpsPaymentControl', params);
}

async function invokeBocPayment(payResultData, payContext = {}) {
  const payPayload = extractBocPayPayload(payResultData);
  if (!hasPaymentControlFields(payPayload)) {
    throw new Error('支付参数解析失败');
  }
  const parsed = parsePayUrlInfo(payPayload);
  if (!parsed || parsed.mode !== 'control') {
    throw new Error('支付参数解析失败');
  }
  if (USE_PCPS_PAYMENT && payContext.payUrlInfo) {
    return callPcpsPaymentControl(buildPcpsPaymentParams(payContext.payUrlInfo, {
      orderId: payContext.orderId || payResultData.OrderId,
      payPlatCode: payContext.payPlatCode || payResultData.PayPlatCode,
      payInfoTids: payContext.payInfoTids || payResultData.PayInfoTids,
    }));
  }
  return callPaymentControl(buildPaymentControlParams(parsed.data));
}

async function weixinOpenMiniProgram(params = {}) {
  await onDeviceReady();
  const miniParams = {
    userName: params.userName || LOONGAIR_MINI_PROGRAM.userName,
    path: params.path || LOONGAIR_MINI_PROGRAM.path,
  };
  if (!miniParams.userName) {
    throw new Error('缺少小程序原始ID');
  }
  if (!miniParams.path) {
    throw new Error('缺少小程序跳转路径');
  }
  return callMerchantBridge('weixinOpenMiniProgram', miniParams);
}

function isRealNameVerified(userInfo) {
  if (!userInfo) {
    return false;
  }
  return !!(
    userInfo.isReal ||
    userInfo.ifReal ||
    userInfo.authFlg ||
    userInfo.IsCertified ||
    userInfo.isCertified
  );
}

function syncUserCertifiedState(user, userInfo) {
  if (!user || !userInfo) {
    return;
  }
  if (userInfo.isCertified !== undefined) {
    user.setIsCertified(userInfo.isCertified);
    return;
  }
  if (userInfo.IsCertified !== undefined) {
    user.setIsCertified(userInfo.IsCertified);
    return;
  }
  if (userInfo.isReal !== undefined) {
    user.setIsCertified(userInfo.isReal);
    return;
  }
  if (userInfo.ifReal !== undefined) {
    user.setIsCertified(userInfo.ifReal);
  }
}

function applyChannelLoginCredentials(result, user) {
  const token = result && (
    result.loongairToken ||
    result.LoongairToken ||
    result.SessionID
  );
  if (token) {
    user.setSessionId(token);
  }
  if (result && result.IsCertified !== undefined) {
    user.setIsCertified(result.IsCertified);
  } else if (result && result.isReal !== undefined) {
    user.setIsCertified(result.isReal);
  }
  if (result) {
    user.setUserInfo(result);
  }
}

async function completeChannelLogin(result, user, fetchUserDetail) {
  applyChannelLoginCredentials(result, user);
  let userInfo = result || null;
  let isReal = isRealNameVerified(userInfo);

  if (typeof fetchUserDetail === 'function') {
    try {
      const res = await fetchUserDetail();
      if (res && res.data && res.data.ErrorCode === 0 && res.data.Result) {
        userInfo = res.data.Result;
        user.setUserInfo(userInfo);
        syncUserCertifiedState(user, userInfo);
        isReal = isRealNameVerified(userInfo);
      }
    } catch (e) {
      console.error(e);
    }
  }

  return {
    userInfo,
    isReal,
  };
}

async function goToBocNative(page = '1') {
  await onDeviceReady();
  return callMerchantBridge('goToNative', { page: String(page) });
}

const PLUS_HOME_PATH = '/plus/cardIntro';

async function handlePlusPageBack(router, options = {}) {
  const fallbackPath = options.fallbackPath || PLUS_HOME_PATH;
  const nativePage = options.nativePage || '1';

  if (window.history.length > 1) {
    router.go(-1);
    return;
  }
  if (isBocApp()) {
    try {
      await goToBocNative(nativePage);
      return;
    } catch (err) {
      console.error(err);
    }
  }
  router.replace(fallbackPath);
}

export default {
  BOC_CHANNEL_NO,
  BOC_MER_ID,
  BOC_PAY_MERCHANT_NO,
  USE_ENCRYPT_USER_UNIQUE_ID,
  BOC_IDENTITY_BRIDGE_METHOD,
  USE_PCPS_PAYMENT,
  isBocApp,
  onDeviceReady,
  getBridgeDiagnostics,
  formatBridgeError,
  getBocCustomerAllInfo,
  getEncryptUserUniqueId,
  parseBocCustomerAllInfoResult,
  parseEncryptUserUniqueIdResult,
  fetchBocCustomerIdentity,
  buildUserLoginLog,
  normalizeCipherText,
  buildChannelAutoLoginParams,
  buildChannelMobileCodeLoginParams,
  isRealNameVerified,
  syncUserCertifiedState,
  applyChannelLoginCredentials,
  completeChannelLogin,
  judgeBocLogin,
  continueBocLogin,
  ensureBocAppLogin,
  clearStoredCipherText,
  callMerchantBridge,
  parsePayUrlInfo,
  extractBocPayPayload,
  normalizePaymentControlFields,
  prepareSignatureForBridge,
  encodePaymentControlParam,
  encodePaymentControlParamIfNeeded,
  prepareMessageForBridge,
  resolveBocPaymentBridgeMethod,
  buildPaymentControlParams,
  buildPcpsPaymentParams,
  callPaymentControl,
  callPcpsPaymentControl,
  invokeBocPayment,
  weixinOpenMiniProgram,
  goToBocNative,
  handlePlusPageBack,
  LOONGAIR_MINI_PROGRAM,
};



// WEBPACK FOOTER //
// ./src/assets/js/bocBridge.js